import { action, computed, makeObservable, observable, toJS } from "mobx";
import { CompanyAttributesAggregation } from "../models/company-attributes/CompanyAttributesAggregation";
import { BaseAttribute } from "../models/company-attributes/attributes-types/BaseAttribute";
import { CompanyPreferenceDto } from "../models/company-attributes/CompanyPreferenceDto";
import { CompanyProfile } from "../models/company-attributes/CompanyProfile";
import { CustomerCampaignAttributesAggregation } from "../models/company-attributes/CustomerCampaignAttributesAggregation";
import { featureFlags } from "../config/featureFlags";



export class AttributesManagementStore {

    @observable
    CompanyAttributesAggregation: CompanyAttributesAggregation = {};

    @observable
    CustomerCampaignAttributesAggregation: CustomerCampaignAttributesAggregation = {};

    @observable
    CompanyPreference: CompanyPreferenceDto = {};

    @observable
    CompanyProfile: CompanyProfile = {};

    @observable
    hasLinkedInValidationErrors: boolean = false;

    constructor() {
        makeObservable(this);
    }

    @action
    public setHasLinkedInValidationErrors(hasErrors: boolean) {
        this.hasLinkedInValidationErrors = hasErrors;
    }


    @action
    public onChangeAttribute = (baseAttribute: BaseAttribute) => {
        baseAttribute.isEdited = true;
    }

    @action
    public async SetAttributes(attributes: CompanyAttributesAggregation) {
        this.CompanyAttributesAggregation = attributes;
    }

    @action
    public async SetCustomerRequest(customerRequest: CustomerCampaignAttributesAggregation) {
        this.CustomerCampaignAttributesAggregation = customerRequest;
    }

    @action
    public async SetCompanyPreference(companyPreferenceDto: CompanyPreferenceDto) {
        this.CompanyPreference = companyPreferenceDto;
    }

    @action
    public async SetCompanyProfile(companyProfile: CompanyProfile) {
        this.CompanyProfile = companyProfile;
    }

    @action
    public getCompanyPreference(): CompanyPreferenceDto {
        return this.CompanyPreference;
    }

    @action
    public getEditedAttributes(userId: number |undefined): Partial<CompanyAttributesAggregation> {

        const editedAttributes: Partial<CompanyAttributesAggregation> = {};
        editedAttributes.userId = userId;
        editedAttributes.companyId = this.CompanyAttributesAggregation.companyId;

        for (const key in this.CompanyAttributesAggregation) {
            const attribute = this.CompanyAttributesAggregation[key];
            if (attribute && attribute.isEdited == true) {
                // Convert MobX observable to plain object
                editedAttributes[key] = toJS(attribute);
            }
        }

        return editedAttributes;
    }

    public resetIsEdited = () => {
        for (const key in this.CompanyAttributesAggregation) {
            const attribute = this.CompanyAttributesAggregation[key];
            if (attribute && attribute.isEdited !== undefined) {
                attribute.isEdited = false;
            }
        }
    }

    public validateCarouselCaps = (): { isValid: boolean; errors: string[] } => {
        const errors: string[] = [];
        const MAX_CAP_VALUE = 150; // Configurable by request

        const validateCapValue = (value: any, fieldName: string): string | null => {
            // If empty or null, it's valid (defaults to 0)
            if (value === null || value === undefined || value === '') {
                return null;
            }
            
            // Check if not a number
            if (isNaN(value) || !Number.isInteger(Number(value))) {
                return `${fieldName}: Enter numbers only.`;
            }
            
            const numValue = Number(value);
            
            // Check if less than 0
            if (numValue < 0) {
                return `${fieldName}: Value must be 0 or greater.`;
            }
            
            // Check if more than max (configurable)
            if (numValue > MAX_CAP_VALUE) {
                return `${fieldName}: Value must be ${MAX_CAP_VALUE} or less.`;
            }
            
            return null;
        };

        // Validate All Vendors Cap
        // const allVendorsError = validateCapValue(this.CompanyAttributesAggregation.allVendorsCap?.cap, 'All Vendors');
        // if (allVendorsError) errors.push(allVendorsError);

        // Validate Indeed Cap
        // const indeedError = validateCapValue(this.CompanyAttributesAggregation.indeedCap?.cap, 'Indeed');
        // if (indeedError) errors.push(indeedError);

        // Validate LinkedIn Cap (Feature Flag Protected)
        if (featureFlags.enableLinkedInCapValidation) {
            const linkedInError = validateCapValue(this.CompanyAttributesAggregation.linkedInCap?.dailyBudgetPercentP4P, 'LinkedIn');
            if (linkedInError) errors.push(linkedInError);
        }

        // Validate CraigsList Budget
        // const craiglistError = validateCapValue(this.CompanyAttributesAggregation.craiglistBudget?.budget, 'CraigsList budget');
        // if (craiglistError) errors.push(craiglistError);

        return {
            isValid: errors.length === 0,
            errors
        };
    }

}






